<template>
    <div class="page-container">
        <div class="welcom-notice">
            <p>您好</p>
            <p>欢迎{{currentTab == 'login' ? '登录' : '注册'}}御粮</p>
        </div>
        <!-- 登录 -->
        <div class="login-form" v-if="currentTab == 'login'">
            <div class="form-line">
                <div class="form-title">手机号</div>
                <div class="input-group">
                    <input type="text" v-model="phone" placeholder="请输入您的手机号" />
                </div>
            </div>
            <div class="form-line">
                <div class="form-title">验证码</div>
                <div class="input-group pic-code">
                    <input type="text" v-model="verficationPic" placeholder="请输入图片计算结果" />
                    <img :src="imgSrc" @click="getPicCode" alt="" class="code-pic">
                </div>
                <div class="input-group pic-code" style="margin-top:10px;">
                    <input type="text" maxlength="6" v-model="verficationMsg" placeholder="请输入短信验证码" />
                    <span class="btn-getcode">
                        <span @click="sendMsg" v-show="!showCountdown">获取验证码</span>
                        <span v-show="showCountdown">(<van-count-down ref="countDown" :time="time" :auto-start="false" format="ss" @finish="countdownFinish" />s)重新获取</span>
                    </span>
                </div>
            </div>
            <div class="btn-login" @click="login">登录</div>
            <div class="bottom-line">
                <span @click="currentTab='register'">立即注册</span>
                <span>|</span>
                <span @click="showLayer = true">遇到问题</span>
            </div>
        </div>
        <!-- 注册 -->
        <div class="login-form" v-else-if="currentTab == 'register'">
            <div class="form-line">
                <div class="form-title">手机号</div>
                <div class="input-group">
                    <input type="text" v-model="phone" placeholder="请输入您的手机号" />
                </div>
            </div>
            <div class="form-line">
                <div class="form-title">验证码</div>
                <div class="input-group pic-code">
                    <input type="text" v-model="verficationPic" placeholder="请输入图片计算结果" />
                    <img :src="imgSrc" @click="getPicCode" alt="" class="code-pic">
                </div>
                <div class="input-group pic-code" style="margin-top:10px;">
                    <input type="text" maxlength="6" v-model="verficationMsg" placeholder="请输入短信验证码" />
                    <span class="btn-getcode">
                        <span @click="sendMsg" v-show="!showCountdown">获取验证码</span>
                        <span v-show="showCountdown">(<van-count-down ref="countDown" :time="time" :auto-start="false" format="ss" @finish="countdownFinish" />s)重新获取</span>
                    </span>
                </div>
                <div class="input-group pic-code" style="margin-top:10px;">
                    <input type="text" v-model="shareCode" placeholder="请输入邀请码" />
                </div>
                <van-radio-group v-model="roles" direction="horizontal">
                    <van-radio name="0">成为合伙人</van-radio>
                    <van-radio name="1">成为推荐人</van-radio>
                </van-radio-group>
            </div>
            <div class="btn-login" @click="register" style="margin-top:0;">立即注册</div>
            <div class="bottom-line">
                <span @click="currentTab='login'">去登录</span>
                <span>|</span>
                <span @click="showLayer = true">遇到问题</span>
            </div>
        </div>

        <!-- 客服弹层 -->
        <van-overlay :show="showLayer" @click="showLayer = false">
            <div class="layer-wrapper">
                <div class="layer-content" @click.stop>
                    <img src="../../assets/login-icon-service.png" class="service-icon" alt="联系客服" />
                    <div class="layer-main-title">请联系客服</div>
                    <div class="service-number">4001017057</div>
                    <div class="service-time">客服工作时间9:00-18:00</div>
                    <div class="btn-group">
                        <div class="btn-cancel btn-item" @click="showLayer = false">取消</div>
                        <a href="tel:4001017057" class="btn-call btn-item">立即呼叫</a>
                    </div>
                </div>
            </div>
        </van-overlay>
    </div>
</template>

<script>
import { Overlay,CountDown,Radio,RadioGroup,Toast } from 'vant'

import $http from '@/lib/request'
import config from '@/config'
import md5 from 'js-md5'
import { setUid } from '@/lib/auth'
import { setLocalUserInfo,checkPhoneValue } from '@/lib/util'

export default {
    data(){
        return{
            currentTab:'login',//当前状态 login 登录，register 注册
            phone:'',
            password:'',
            showLayer:false,//是否展示客服弹层
            verficationPic:'',//图片验证码
            verficationMsg:'',//短信验证码
            time: 60 * 1000,//短信验证码倒计时
            showCountdown:false,//是否展示倒计时
            shareCode:'',//邀请码，1 高级合伙人，2  合伙人
            roles:"",//想要成为的人，0 高级合伙人，1 合伙人
            imgSrc:'',//图片验证码
            originImgsrc:'',//接口返回的原始图片验证码流
        }
    },
    activated(){
        this.getPicCode();
    },
    deactivated(){
        this.phone='';
        this.password='';
        this.showLayer=false;//是否展示客服弹层
        this.verficationPic='';//图片验证码
        this.verficationMsg='';//短信验证码
        this.time= 60 * 1000;//短信验证码倒计时
        this.showCountdown=false;//是否展示倒计时
        this.shareCode='';//邀请码，1 高级合伙人，2  合伙人
        this.roles="";//想要成为的人，0 高级合伙人，1 合伙人
        this.imgSrc='';//图片验证码
        this.originImgsrc='';//接口返回的原始图片验证码流
    },
    components:{
        [Overlay.name]:Overlay,
        [CountDown.name]:CountDown,
        [Radio.name]:Radio,
        [RadioGroup.name]:RadioGroup,
        [Toast.name]:Toast
    },
    methods:{
        //获取图片验证码
        getPicCode(){
            $http({
                method:'post',
                url:config.api.graphCode
            }).then((res)=>{
                if(res.errno == 0){
                    this.imgSrc='data:image/png;base64,'+res.data.imgsrc;
                    this.originImgsrc=res.data.imgsrc;
                }else{
                    Toast(res.errmsg);
                }
            })
        },
        login(){
            if(!checkPhoneValue(this.phone)){
                Toast('请输入正确手机号');
                return;
            }
            $http({
                method:'post',
                data:{
                    mobile:this.phone,
                    qrCode:this.verficationMsg
                },
                url:config.api.login
            }).then(res=>{
                if(res.errno == 0){
                    setUid(res.data.userId);
                    this.$store.commit('setUid',),res.data.userId;
                    this.$store.commit('setUserInfo',res.data);
                    setLocalUserInfo(res.data);
                    Toast('登录成功');
                    setTimeout(()=>{
                        this.$router.replace({name:'index'});
                    },2000);
                }else{
                    Toast(res.errmsg)
                }
                
            })
        },
        // 注册
        register(){
            if(!checkPhoneValue(this.phone)){
                Toast('请输入正确手机号');
                return;
            }
            if(this.roles == ''){
                Toast('请选择要成为的角色');
                return;
            }
            $http({
                method:'post',
                data:{
                    mobile:this.phone,
                    inviteCode:this.shareCode,
                    // tobeLevel:this.roles,
                    userRole:this.roles,
                    qrCode:this.verficationMsg
                },
                url:config.api.register
            }).then((res)=>{
                if(res.errno == 0){
                    setUid(res.data.userId);
                    this.$store.commit('setUid',),res.data.userId;
                    setLocalUserInfo(res.data);
                    Toast('恭喜你，注册成功！');
                    setTimeout(()=>{
                        this.$router.replace({name:'index'});
                    },2000);
                }else{
                    Toast(res.errmsg)
                }
            })
        },
        //发送短信验证码
        sendMsg(){
            if(!checkPhoneValue(this.phone)){
                Toast('请输入正确手机号');
                return;
            }
            $http({
                method:'post',
                data:{
                    mobile:this.phone,
                    verifyCode:this.verficationPic,
                    vCodeKey:'vcode'+md5(this.originImgsrc),
                    type:this.currentTab == 'login' ? "1" : "2"
                },
                url:config.api.getSmsCode
            }).then(res=>{
                if(res.errno == 0){
                    Toast('验证码发送成功，5分钟内有效！');
                    // 开始倒计时
                    this.showCountdown=true;
                    this.$refs.countDown.start();
                }else{
                    Toast(res.errmsg);
                    //更新图片验证码
                    this.verficationPic='';
                    this.getPicCode();
                }
            });
        },
        countdownFinish(){
            this.showCountdown=false;
            this.$refs.countDown.reset();
        }
    }
}
</script>

<style lang="scss" scoped>
@mixin flex-between{
    display: flex;
    justify-content: space-between;
    align-items: center;
}
::v-deep .van-count-down{
    display: inline;
    color:#3088F5;
}
::v-deep .van-radio-group--horizontal{
    padding-top:20px;
}
.page-container{
    width:100vw;
    height:100vh;
    background: linear-gradient(333deg, #3CA7FE 0%, #3088F5 100%);
    position: relative;
    input:-webkit-autofill {
        -webkit-box-shadow: 0 0 0px 1000px #ffffff inset !important;
    }
    .welcom-notice{
        color:#fff;
        box-sizing: border-box;
        padding-left: 36px;
        padding-top: 40px;
        p{
            font-size: 24px;
            font-weight: 500;
            line-height: 34px;
            margin:0;
        }
    }
    .login-form{
        position: absolute;
        background:#fff;
        border-radius: 30px 30px 0px 0px;
        width:100vw;
        // height:460px;
        height: 80vh;
        left:0;
        bottom:0;
        box-sizing: border-box;
        padding:36px;
        padding-top: 46px;
        .form-line{
            margin-bottom: 24px;
            .form-title{
                font-size: 18px;
                color:#333;
                line-height: 24px;
                font-weight: 500;
            }     
            .input-group{
                position: relative;
                padding:10px 0;
                border-bottom: 1px solid #f0f0f0;
                input{
                    width:166px;
                    border:none;
                    outline: none;
                    height:22px;
                    padding:0;
                    font-size: 16px;
                }
                &.pic-code{
                    @include flex-between();
                    .code-pic{
                        width:70px;
                        min-height:30px;
                    }
                    .btn-getcode{
                        font-size: 16px;
                        color:#3088F5;
                        line-height: 22px;
                    }
                }
                .eye-icon{
                    position: absolute;
                    top:50%;
                    right:16px;
                    transform: translateY(-50%);
                }
            }
        }
        .btn-login{
            height: 44px;
            line-height: 44px;
            border-radius: 26px;
            font-size: 18px;
            color:#fff;
            text-align: center;
            margin-top: 35px;
            background: linear-gradient(300deg, #5EBDFB 0%, #3088F5 100%);
            
        }
        .bottom-line{
            display: flex;
            justify-content: center;
            align-items: center;
            font-size: 14px;
            line-height: 20px;
            color:#3088F5;
            width:100vw;
            position: fixed;
            left:0;
            bottom:35px;
            &>span:nth-child(2){
                margin:0 4px;
                font-size: 18px;
            }
        }
    }
    //客服弹层
    .layer-wrapper{
        display: flex;
        align-items: center;
        justify-content: center;
        height:100%;
    }
    .layer-content{
        width: 316px;
        box-sizing: border-box;
        padding:20px;
        background:#fff;
        border-radius: 6px;
        text-align: center;
        .service-icon{
            width:90px;
            height:84px;
            margin:8px auto;
            display: block;
        }
        .layer-main-title{
            color:#333;
            font-size: 14px;
            line-height: 20px;
        }
        .service-number{
            color:#333;
            font-weight: 500;
            margin:4px 0;
            font-size: 18px;
            line-height: 26px;
        }
        .service-time{
            color:#3088f5;
            font-size: 14px;
            line-height: 18px;
        }
        .btn-group{
            display: flex;
            justify-content: space-between;
            align-items: center;
            margin-top: 26px;
            .btn-item{
                width:132px;
                height:40px;
                line-height: 40px;
                border-radius: 26px;
                font-size: 16px;
                &.btn-cancel{
                    border:1px solid #e7e7e7;
                }
                &.btn-call{
                    background: linear-gradient(296deg, #5EBDFB 0%, #3088F5 100%);
                    color: #fff;
                }
            }
        }
    }
}
</style>